// extracted by mini-css-extract-plugin
export default {"main":"Main_main__g5iOi","content":"Main_content__0cLQE","child":"Main_child__5SdQo","spaceMobile":"Main_spaceMobile__pq6fz"};